'use strict';
import { siteConfig } from './siteConfig';
module.exports = function (Department, Form) {
    let myDepartments = null;
    let loadingPromise = null;
    
    return {
        set: function (departments) {
            myDepartments = departments;
        },
        get: function () {
            if(myDepartments)
                return JSON.parse(JSON.stringify(myDepartments));
            return ;
        },
        updateDepartmentOwners: function (departmentId, owners) {
            if (!myDepartments || departmentId == null) {
                return;
            }
            var dept = myDepartments.find(function (d) {
                return d.id == departmentId;
            });
            if (dept) {
                dept.owners = JSON.parse(JSON.stringify(owners || []));
            }
        },
        load: function (fromMySubscriptions) {
            // console.log("myDepartment.load")
            if (loadingPromise) {
                return loadingPromise;
            }

            var _this = this;
            if (fromMySubscriptions)
                loadingPromise = Form.mySubscriptions({builder:1}).$promise.then(function (subscriptions) {
                    _this.set(subscriptions.response.filter(dept => siteConfig.deptsId.length == 0 || siteConfig.deptsId.includes(dept.id)));
                    loadingPromise = null;
                    return _this.get();
                }).catch(function (error) {
                    loadingPromise = null;
                    return Promise.reject(error);
                });                
            else {
                loadingPromise = Department.myDepartments().$promise.then(function (departments) {
                    return Form.mySubscriptions({ builder: 1 }).$promise.then(function (subscriptions) {
                        for (let dept of subscriptions.response.filter(dept => siteConfig.deptsId.length == 0 || siteConfig.deptsId.includes(dept.id))) {
                            if (departments.response.find(d => d.id == dept.id) == undefined)
                                departments.response.push({ ...dept, subscription: true });
                        }
                        _this.set(departments.response);
                        loadingPromise = null;
                        return _this.get();
                    });
                }).catch(function (error) {
                    loadingPromise = null;
                    return Promise.reject(error);
                });
            }
            return loadingPromise;
        },
    };
};
